import { Config } from "../types";

/**
 * 메인 설정 객체
 */
export const CONFIG: Config = {
  /* ==========================================================================
     ENVIRONMENT SETTINGS
     ========================================================================== */
  ENVIRONMENT: "production",
  DEBUG: false,
  VERSION: "1.0.0",

  /* ==========================================================================
     API & EXTERNAL SERVICES
     ========================================================================== */
  // Google Apps Script 웹 앱 URL (실제 URL로 교체 필요)
  FORM_SCRIPT_URL:
    "https://script.google.com/macros/s/AKfycbyuktaFAgw2ok_Pf9A3aDAM3Hga-qCU6xMzg-58LOIvsI6zmNc4s-uhzMMrhQW0rojiIg/exec",

  // PDF 샘플 파일 경로
  PDF_SAMPLE_PATH: "/contents/sample.pdf",

  // 이미지 경로 (Public 디렉토리)
  IMAGES: {
    HERO_BG: "/contents/hero_img.png",
    LOGO: "/contents/logo.png",
    LOGO_FULL_URL: "https://drawer.co.kr/contents/logo.png",
    PROMO_VIDEO: "/contents/mockup_video.gif",
    CTA_BG: "/contents/b2b.jpg",
  },

  /* ==========================================================================
     ANIMATION SETTINGS
     ========================================================================== */
  ANIMATIONS: {
    SCROLL_THROTTLE: 16, // 스크롤 이벤트 스로틀링 (60fps)
    RESIZE_DEBOUNCE: 250, // 리사이즈 이벤트 디바운싱
    FADE_IN_DELAY: 200, // 페이드인 애니메이션 간격
    CARD_HOVER_DURATION: 300, // 카드 호버 애니메이션 시간
    REVIEW_SCROLL_AMOUNT: 340, // 리뷰 슬라이더 스크롤 거리
  },

  /* ==========================================================================
     UI SETTINGS
     ========================================================================== */
  UI: {
    HEADER_SCROLL_THRESHOLD: 100, // 헤더 스타일 변경 기준점
    HEADER_HIDE_THRESHOLD: 200, // 헤더 숨김 기준점
    MOBILE_BREAKPOINT: 768, // 모바일 화면 기준점
    TABLET_BREAKPOINT: 1024, // 태블릿 화면 기준점
  },

  /* ==========================================================================
     FORM SETTINGS
     ========================================================================== */
  FORM: {
    SUBMISSION_TIMEOUT: 10000, // 폼 제출 타임아웃 (10초)
    VALIDATION_DELAY: 500, // 실시간 검증 지연시간
    REQUIRED_FIELDS: [
      "customer-name",
      "contact-info",
      "inquiry-type",
      "inquiry-message",
    ],
  },

  /* ==========================================================================
     CONTACT INFORMATION
     ========================================================================== */
  CONTACT: {
    // 비즈니스 전화번호
    BUSINESS_PHONE: "02-2135-3096",
    CUSTOMER_SERVICE: "1588-1234",

    // 이메일
    EMAIL: "request@utopsoft.co.kr ",
    BUSINESS_HOURS: "평일 9:00-18:00",
    ADDRESS: "서울특별시 강남구 테헤란로 123",
  },

  /* ==========================================================================
     ERROR MESSAGES
     ========================================================================== */
  MESSAGES: {
    FORM_SUCCESS: "문의가 성공적으로 접수되었습니다. 감사합니다.",
    FORM_ERROR: "오류가 발생했습니다. 다시 시도해주세요.",
    FORM_VALIDATION_ERROR: "필수 항목을 모두 입력해주세요.",
    NETWORK_ERROR: "네트워크 연결을 확인해주세요.",
    BROWSER_NOT_SUPPORTED: "지원하지 않는 브라우저입니다.",
    PDF_LOAD_ERROR: "PDF 파일을 불러올 수 없습니다.",
  },

  /* ==========================================================================
     SEO & METADATA
     ========================================================================== */
  SEO: {
    SITE_NAME: "기억의 서랍",
    SITE_DESCRIPTION: "AI와 함께 만드는 특별한 스토리북 서비스",
    SITE_KEYWORDS: "AI 스토리북, 시니어 스토리북, 기억의 서랍, 인생이야기",
    AUTHOR: "기억의 서랍 팀",
    LANGUAGE: "ko-KR",
    SITE_URL: "https://drawer.co.kr",
    CANONICAL_URL: "https://drawer.co.kr",
  },

  /* ==========================================================================
     ANALYTICS SETTINGS
     ========================================================================== */
  ANALYTICS: {
    GOOGLE_ANALYTICS_ID: "", // GA4 측정 ID (설정 시 입력)
    TRACK_SCROLL: true, // 스크롤 추적
    TRACK_CLICKS: true, // 클릭 추적
    TRACK_FORM_SUBMISSION: true, // 폼 제출 추적
    TRACK_FILE_DOWNLOADS: true, // 파일 다운로드 추적
  },

  /* ==========================================================================
     SOCIAL MEDIA
     ========================================================================== */
  SOCIAL: {
    FACEBOOK: "#",
    INSTAGRAM: "#",
    NAVER_BLOG: "#",
    YOUTUBE: "#",
    KAKAO_CHANNEL: "#",
  },

  /* ==========================================================================
     FEATURE FLAGS
     ========================================================================== */
  FEATURES: {
    ENABLE_FLIPBOOK: true, // PDF 플립북 기능
    ENABLE_ANALYTICS: false, // 분석 도구 활성화 (프로덕션에서 true)
    ENABLE_CHATBOT: false, // 챗봇 기능 (향후 추가)
    ENABLE_A_B_TESTING: false, // A/B 테스트
    ENABLE_PUSH_NOTIFICATIONS: false, // 푸시 알림
  },

  /* ==========================================================================
     PERFORMANCE SETTINGS
     ========================================================================== */
  PERFORMANCE: {
    LAZY_LOADING: true, // 이미지 지연 로딩
    PRELOAD_CRITICAL_IMAGES: true, // 중요 이미지 미리 로딩
    CACHE_STATIC_ASSETS: true, // 정적 자산 캐싱
    OPTIMIZE_FONTS: true, // 폰트 최적화
  },

  /* ==========================================================================
     ACCESSIBILITY SETTINGS
     ========================================================================== */
  ACCESSIBILITY: {
    HIGH_CONTRAST_MODE: false, // 고대비 모드
    LARGE_TEXT_MODE: false, // 큰 글씨 모드
    REDUCED_MOTION: false, // 애니메이션 감소
    SCREEN_READER_SUPPORT: true, // 스크린 리더 지원
  },
};

/**
 * 환경별 설정 로그
 */
if (CONFIG.DEBUG) {
  console.log("🛠️ 개발 모드로 실행 중");
  console.log("설정:", CONFIG);
}
